import dagre from "dagre";
import type { WorkflowGraphNode, WorkflowGraphEdge } from "./workflow-graph";

const NODE_WIDTH = 160;
const NODE_HEIGHT = 160;

export type LayoutDirection = "TB" | "LR" | "BT";

export function layoutGraph(
  nodes: WorkflowGraphNode[],
  edges: WorkflowGraphEdge[],
  direction: LayoutDirection = "TB",
): WorkflowGraphNode[] {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: direction, nodesep: 40, ranksep: 60 });

  for (const n of nodes) {
    g.setNode(n.id, { width: NODE_WIDTH, height: NODE_HEIGHT });
  }
  for (const e of edges) {
    g.setEdge(e.source, e.target);
  }

  dagre.layout(g);

  return nodes.map((n) => {
    const pos = g.node(n.id);
    return {
      ...n,
      position: {
        x: pos.x - NODE_WIDTH / 2,
        y: pos.y - NODE_HEIGHT / 2,
      },
    };
  });
}
